import { render, staticRenderFns } from "./SocketIO.vue?vue&type=template&id=1f752b69&"
import script from "./SocketIO.vue?vue&type=script&lang=js&"
export * from "./SocketIO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports